const AudioRecorderActionTypes = {
    RESET_AUDIO_RECORDER_STATE: 'RESET_AUDIO_RECORDER_STATE',
    RESET_RECORDING_CONTEXT: 'RESET_RECORDING_CONTEXT',
    SET_HAS_MICROPHONE_RESTARTED: 'SET_HAS_MICROPHONE_RESTARTED',
    SET_IS_RESTARTING_MICROPHONE: 'SET_IS_RESTARTING_MICROPHONE',
    SET_RECORDING_CONTEXT: 'SET_RECORDING_CONTEXT',
};
export default AudioRecorderActionTypes;
